import groq from 'groq';
import { ComponentType } from '$lib/sanity/types';
import { RichTextFragment } from './text';
import { ImageComponentFragment } from './image';

export const VideoComponentFragment = groq`
  defined(muxVideo) => {
    "muxVideo": muxVideo.asset->
  }
`;

export const MediaComponentFragment = groq`
...,
${ImageComponentFragment},
defined(video) => {
  "video": video -> {
    ...,
    ${VideoComponentFragment}
  }
},
caption {
  ...,
  copy[] {
    ${RichTextFragment}
  }
}
`;

export const GetMediaComponent = groq`
*[_type == "${ComponentType.Media}" && _id == $id]{
  ${MediaComponentFragment}
}[0]
`;

export const GetImageComponentQuery = groq`
*[_type == "${ComponentType.Image}" && _id == $id]{
  ...,
  ${ImageComponentFragment}
}[0]`;

export const GetVideoQuery = groq`
  *[_type == "${ComponentType.Video}" && _id == $id]{
    ...,
    ${VideoComponentFragment}
  }[0]
`;
